import CreateGalleryContainer from "../containers/CreateGalleryContainer";

const CreateGalleryPage = () => {
  return (
    <CreateGalleryContainer />
  );
};

export default CreateGalleryPage;
